<template>
    <div id="operations_filter"
        style="display: flex; justify-content: space-between;">
        <div> </div>
        <div class="ui segment"
            :style="{
                width: (filter.is_advanced_mode) ? '100%' : 'auto',
                margin: 0
            }"
            >
            <!-- Filter -->
            <Header
                class="right floated"
            ></Header>

            <div class="clear"></div>
            <transition name="slide-fade" mode="out-in">
                <Advanced v-if="filter.is_advanced_mode"
                ></Advanced>
            </transition>
        </div>
    </div>
</template>

<script>
import Advanced from "./advanced.vue"
import Header from "./header.vue"

export default {
    name: "OperationsFilter",
    data() {
        return {
            is_initialized: false,
        }
    },
    computed: {
        current_store() {
            return this.$store.state.provider.operations_module
        },
        filter() {
            return this.current_store.filter
        },
    },
    created() {
    },
    mounted() {
    },
    watch: {
        'filter.is_advanced_mode'(value) {
            if (!value) {
                this.$store.commit('provider/operations_module/init_filter_columns')
            }
        }
    },
    methods: {
    },
    components: {
        Advanced,
        Header
    }
}
</script>
